export const filterCompaniesByRelationships = (companies, relationships) => {
  if (!relationships?.length) return companies || [];
  return (companies || []).filter((company) => relationships.includes(company.relacionamento));
};

export const resolveDismissedReportCompanyIds = ({
  selectedCompanies = [],
  selectedRelationships = [],
  allCompanies = [],
}) => {
  if (selectedCompanies.length > 0) {
    return selectedCompanies.map((company) => company.idFolha);
  }

  if (selectedRelationships.length > 0) {
    return filterCompaniesByRelationships(allCompanies, selectedRelationships).map((company) => company.idFolha);
  }

  return (allCompanies || []).map((company) => company.idFolha);
};
